import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dropzone from 'react-dropzone';
import { Redirect } from 'react-router-dom';
import { uploadDocumentToS3, getUploadUrl } from 'services/uploader';
import validator from 'services/validator';
import { format } from 'date-fns';

import TitleWithShape from 'components/TitleWithShape';
import IconButton from 'components/IconButton';
import HelpText from 'components/HelpText';
import InputField from 'components/InputField';
import BackButton from 'components/BackButton';
import Tile from 'components/Tile';
import DatePicker from 'components/DatePicker';

import HelpIcon from 'assets/images/icons/help-icon.svg';
import WarningIcon from 'assets/images/warning.png';

const Wrapper = styled.div`
  color: #35447d;
  display: flex;
  justify-content: center;
  padding-left: 5.4rem;
  padding-right: 5.4rem;
  margin-top: 7.1rem;
  .form-wrapper {
    background: #f8f7f3;
    width: 66rem;
    position: relative;
    .bar-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 3rem;
      padding-right: 3.7rem;
      padding-left: 3.7rem;
    }
    .form-title {
      margin-top: 6.2rem;
      margin-left: 10.3rem;
    }
    .content {
      padding: 6rem 10rem 10rem 10rem;
      .dropzone {
        display: none;
      }
      .fields {
        margin-top: 5rem;

        .required {
          font-size: 1.4rem;
          margin: 0;
        }
        .complete {
          display: flex;
          margin-top: 5rem;
        }
        .warning {
          margin-top: 3.6rem;
          display: flex;
          width: 36rem;
          border: 1px dashed #35447d;
          padding: 1.5rem;
          .warning-icon {
            margin-right: 1rem;
            width: 3rem;
            height: 3rem;
            border: 1px solid #35447d;
            border-radius: 3rem;
            display: flex;
            align-items: center;
            img {
              margin: auto;
              width: 60%;
            }
          }
          .warning-info {
            flex: 1;
          }
        }
      }
      .next-button {
        margin-top: 5rem;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .info-wrapper {
    margin-left: 12rem;
    margin-top: 6rem;
    width: 36rem;
    .file-list {
      padding-top: 5rem;

      h1 {
        margin-bottom: 3rem;
        font-size: 3.6rem;
      }
      .upload-info {
        border: 1px dashed #35447d;
        display: flex;
        padding: 2rem;
        img {
          width: 3rem;
          height: 3rem;
          margin-right: 2rem;
        }
        div {
          font-size: 1.3rem;
          flex: 1;
        }
      }
    }
    h4 {
      font-size: 1.8rem;
      font-weight: 400;
      letter-spacing: 1px;
    }
    .suggestion {
      margin-top: 2rem;
    }
  }
  @media only screen and (max-width: 1100px) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    .form-wrapper { max-width: 100%; }
    .info-wrapper {
      margin-top: 1rem;
      margin-bottom: 8rem;
      margin-left: 0;

      .file-list { padding-top: 0; }
    }
  }
`;

class Step5 extends Component {
  constructor(props) {
    super(props);
    this.state = props.formData;
    // Set defaults
    this.state.submitted = false;
    this.state.isEditing = this.state.isEditing || false;
    this.state.isFileAttached = this.state.isFileAttached || false;
    this.state.redirect = this.state.redirect || false;
    this.state.documentDate = this.state.documentDate || null;
    this.state.file = this.state.file || '';
    this.state.fileName = this.state.fileName || '';
    this.state.description = this.state.description || '';
    this.state.author = this.state.author || '';
    this.state.relevance = this.state.relevance || '';
    this.state.received = this.state.received || '';
    this.state.editIndex = this.state.editIndex || '';
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onChange = (e, key) => {
    this.setState({ [key]: e.target.value });
  }

  onDeleteDocument = () => {
    const newDocuments = this.props.documents.filter((elem, i) => i !== this.state.editIndex);
    // Update session
    this.props.collectData('documents', newDocuments);
    this.clearDocumentState();
  }

  onDrop = (file) => {
    this.setState({
      isFileAttached: true,
      fileName: file[0].name,
      file: file[0],
    });
  }

  onEditDocument = (index) => {
    this.setState({
      isEditing: true,
      isFileAttached: true,
      editIndex: index,
      fileName: this.props.documents[index].fileName,
      documentDate: this.props.documents[index].documentDate,
      description: this.props.documents[index].description,
      author: this.props.documents[index].author,
      relevance: this.props.documents[index].relevance,
      received: this.props.documents[index].received,
    });
  }

  onSaveDocument = () => {
    if (!this.validate() || this.props.documents >= 8) {
      console.log(this.state);
      return;
    }
    this.setState({ submitted: true });
    // Increase index
    let newIndex = this.props.documents.length;
    // If editing => replace document
    if (this.state.isEditing) {
      newIndex = this.state.editIndex;
    } else {
      uploadDocumentToS3(this.props.uuid, this.state.file)
        .then(uploadPath => getUploadUrl(uploadPath))
        .then((fileUrl) => {
          const newDocuments = this.props.documents.slice();
          newDocuments.splice(newIndex, this.state.isEditing ? 1 : 0, {
            index: newIndex,
            file: fileUrl,
            fileName: this.state.fileName,
            documentDate: this.state.documentDate ? format(this.state.documentDate, 'DD/MM/YYYY') : 'N/A',
            description: this.state.description,
            author: this.state.author,
            relevance: this.state.relevance,
            received: this.state.received,
          });
          this.props.collectData('documents', newDocuments);
          this.clearDocumentState();
        });
    }
  }

  setDate = (date) => {
    this.setState({ documentDate: date });
  }

  clearDocumentState = () => {
    this.setState({
      isEditing: false,
      isFileAttached: false,
      submitted: false,
      documentDate: null,
      fileName: '',
      description: '',
      author: '',
      relevance: '',
      received: '',
      editIndex: '',
      file: '',
    });
  }

  validate() {
    const newState = validator.validate(this.state, ['description']);
    this.setState(newState);
    return newState.isValid;
  }

  nextFormPage() {
    this.setState({
      completed: true,
    }, () => {
      this.props.collectData('step5', this.state);
      this.setState({ redirect: '/get-started/step-six' });
    });
  }

  render() {
    const { isFileAttached, fileName } = this.state;
    let dropzoneRef;

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    return (
      <Wrapper>
        <div className="form-wrapper">
          <div className="bar-wrapper">
            <BackButton />
          </div>
          <div className="form-title">
            <TitleWithShape
              title="Document upload"
              subTitle="Please add any relevant documents."
            />
          </div>
          <div className="content">
            <div className="dropzone">
              <Dropzone
                ref={(node) => { dropzoneRef = node; }}
                onDrop={this.onDrop}
              />
            </div>
            {
              !isFileAttached && this.props.documents.length === 0 && (
                <div style={{ display: 'flex' }}>
                  <IconButton
                    width={25}
                    name="Upload a document"
                    icon="document"
                    rightMargin={2}
                    onClick={() => { dropzoneRef.open(); }}
                    selected
                    noBorder
                  />
                  <IconButton
                    name="Skip"
                    icon="downArrow"
                    onClick={() => this.nextFormPage()}
                    background="#e6e6e6"
                    noBorder
                  />
                </div>)
            }
            {
              isFileAttached &&
              <IconButton
                background="transparent"
                width={25}
                name={fileName}
                icon="close"
                onClick={this.clearDocumentState}
                inline
              />
            }
            {
              isFileAttached &&
              <div className="fields">
                <DatePicker
                  hint="Document date"
                  onChange={this.setDate}
                  value={this.state.documentDate}
                />
                <InputField
                  value={this.state.description}
                  name="description"
                  placeholder="Description"
                  onChange={this.onChange}
                  error={this.state.descriptionError}
                  isRequired
                />
                <InputField value={this.state.author} name="author" placeholder="Document author/creator" onChange={this.onChange} />
                <InputField value={this.state.relevance} name="relevance" placeholder="What is the relevance of the document?" onChange={this.onChange} />
                <InputField value={this.state.received} name="received" placeholder="How did you receive the document, and when?" onChange={this.onChange} />

                <div className="complete">
                  {this.state.isEditing
                    ? (
                      <div>
                        <IconButton
                          width={25}
                          name="Update document"
                          icon="confirm"
                          onClick={this.onSaveDocument}
                          rightMargin={2}
                          selected
                          noBorder
                        />
                        <IconButton
                          background="#e1e1e1"
                          width={15}
                          name="Delete"
                          icon="delete"
                          onClick={this.onDeleteDocument}
                          topMargin={2}
                          noBorder
                        />
                      </div>)
                    : (
                      <IconButton
                        width={25}
                        name="Save document"
                        icon="confirm"
                        onClick={this.onSaveDocument}
                        rightMargin={2}
                        selected
                        noBorder
                        loading={this.state.submitted}
                        disabled={this.state.submitted}
                      />)
                  }
                  <IconButton
                    background="#e1e1e1"
                    width={15}
                    name="Cancel"
                    icon="close"
                    onClick={this.clearDocumentState}
                    noBorder
                  />
                </div>
              </div>
            }
            {
              !isFileAttached && this.props.documents.length > 0 &&
              <div className="fields">
                <IconButton
                  background="transparent"
                  width={20}
                  name="Add document"
                  icon="plus"
                  onClick={() => { dropzoneRef.open(); }}
                  disabled={this.props.documents.length >= 8}
                />
                <div className="warning">
                  <div className="warning-icon">
                    <img alt="warning" src={WarningIcon} />
                  </div>
                  <div className="warning-info">
                    If the combined document word count of all your uploads exceeds 10,000 words, you may
                    be changed an additional fee at a later date at a rate of $165 per additional 2,000 words.
                  </div>
                </div>
                <div className="next-button">
                  <IconButton
                    name="Save and continue"
                    icon="downArrow"
                    onClick={() => this.nextFormPage()}
                    selected
                    noBorder
                  />
                </div>
              </div>
            }
          </div>
        </div>
        <div className="info-wrapper">
          {!isFileAttached && this.props.documents.length === 0 &&
            <HelpText>Start by uploading a document</HelpText>
          }
          {isFileAttached &&
            <div>
              <HelpText>
                Now give us a little information about your document.<br /><br />
                Here's an example:
              </HelpText>
              <div className="suggestion">
                <InputField
                  placeholder="Document date"
                  help={`This could be a specific date(e.g. 12/07/2017), a general date(e.g. May 2017) or if you're unsure you can type "unsure".`}
                  value="May of 2017"
                  isRequired
                  disabled
                />
                <InputField
                  placeholder="Description"
                  value="Notice of remedy breach"
                  isRequired
                  disabled
                />
                <InputField
                  placeholder="Document author/creator"
                  value="Property Owner Pty Ltd(Landlord)"
                  disabled
                />
                <InputField
                  placeholder="What is the relevance of the document?"
                  value="Lists a number of failures to comply with my lease, and threatens to terminate the lease if they are not fixed"
                  height="80px"
                  textarea
                  disabled
                />
                <InputField
                  placeholder="How did you receive the document, and when?"
                  value="By letter dated 2 May 2017, from the solicitors for the landlord"
                  textarea
                  disabled
                />
              </div>
            </div>
          }
          {!isFileAttached && this.props.documents.length === 0 &&
            <h4>This could include Court documents, correspondence, agreements, leases, demands,
            invoices, or any other relevant documents. <br /><br />
            You'll be able to link these documents to a timeline of events that you create in the next step (step 6).
            </h4>
          }
          {!isFileAttached && this.props.documents.length > 0 &&
            <div className="file-list">
              <h1>Uploaded</h1>
              {this.props.documents.map((file, index) => (
                <Tile
                  key={index}
                  date={file.documentDate}
                  description={file.description}
                  name={file.fileName.toUpperCase()}
                  onClick={() => this.onEditDocument(index)}
                  showIcon
                />
              ))}
              <div className="upload-info">
                <img alt="help-icon" src={HelpIcon} />
                <div>
                  You can add a maximum of eight documents
                </div>
              </div>
            </div>
          }
        </div>
      </Wrapper>
    );
  }
}

Step5.propTypes = {
  collectData: PropTypes.func.isRequired,
  documents: PropTypes.arrayOf(PropTypes.any).isRequired,
  formData: PropTypes.objectOf(PropTypes.any).isRequired,
  uuid: PropTypes.string.isRequired,
};

export default Step5;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Step5.js